class ZoomableImage extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector(".js-zoom-trigger");
    this.imageId = this.trigger.dataset.zoom;
    this.imageToZoom = "zoom--" + this.imageId;
    this.resultImage = "zoom-result--" + this.imageId;
    this.idOfImage = `#${this.imageToZoom}`;
    this.image = this.querySelector(this.idOfImage);
    this.splideExists = this.parentElement.classList.contains('splide__slide');
    this.trigger.addEventListener("click", (e) => {
      this.trigger.dataset.zoomed === "off" ?
      (
        this.trigger.dataset.zoomed = "on",
        this.imageZoom(this.imageToZoom, this.resultImage, e)
      ) : (
        this.zoomOut()
      )
    })
    /*
    const tablet = window.matchMedia("(min-width: 750px)")
    
    if (tablet.matches) {
      this.image.addEventListener('touchstart', (e) => {
          this.trigger.dataset.zoomed = "on";
          this.imageZoom(this.imageToZoom, this.resultImage, e);
      })
    }
    */

    document.addEventListener("click", (e) => {
      if (this.contains(e.target)) {
        return;
      } 
      /*
      else if (!tablet.matches) {   
        this.zoomOut();
      }
      */
    });
  }

  imageZoom = (imgID, resultID, e) => {
    /* stop multiple events from firing in tablet / mobile */
    e.stopImmediatePropagation();
    var img, lens, result, cx, cy;

    /* 
      -get real active image using splide's 'is-visible' class, instead of zooming a cloned image out of viewport
      -default to original logic if not using splide (i.e. with gift card pdp) */
    img = this.splideExists ? document.querySelector(`.is-visible #${imgID}`) : document.querySelector(`#${imgID}`);
    result = this.splideExists ? document.querySelector(`.is-visible #${resultID}`) : document.querySelector(`#${resultID}`);
  
    /* Create lens: */
    lens = document.createElement("DIV");
    lens.setAttribute("class", "img-zoom-lens");
    /* Insert lens: */
    img.parentElement.insertBefore(lens, img);
    /* Calculate the ratio between result DIV and lens: */
    cx = result.offsetWidth / lens.offsetWidth;
    cy = result.offsetHeight / lens.offsetHeight;
    /* Set background properties for the result DIV */
    result.style.backgroundColor = "#fff";
    result.style.backgroundImage = "url('" + img.src + "')";
    result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
    /* Execute a function when someone moves the cursor over the image, or the lens: */
    lens.addEventListener("mousemove", moveLens);
    img.addEventListener("mousemove", moveLens);
    /* And also for touch screens: */
    lens.addEventListener("touchmove", moveLens);
    img.addEventListener("touchmove", moveLens);
  
    function moveLens(e) {
      var pos, x, y;
      /* Prevent any other actions that may occur when moving over the image */
      e.preventDefault();
      /* Get the cursor's x and y positions: */
      pos = getCursorPos(e);
      /* Calculate the position of the lens: */
      x = pos.x - (lens.offsetWidth / 2);
      y = pos.y - (lens.offsetHeight / 2);
      /* Prevent the lens from being positioned outside the image: */
      if (x > img.width - lens.offsetWidth) {x = img.width - lens.offsetWidth;}
      if (x < 0) {x = 0;}
      if (y > img.height - lens.offsetHeight) {y = img.height - lens.offsetHeight;}
      if (y < 0) {y = 0;}
      /* Set the position of the lens: */
      lens.style.left = x + "px";
      lens.style.top = y + "px";
      /* Display what the lens "sees": */
      result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
    }
    
    function getCursorPos(e) {
      var a, x = 0, y = 0;
      e = e || window.event;
      /* Get the x and y positions of the image: */
      a = img.getBoundingClientRect();
      /* Calculate the cursor's x and y coordinates, relative to the image: */
      x = e.pageX - a.left;
      y = e.pageY - a.top;
      /* Consider any page scrolling: */
      x = x - window.pageXOffset;
      y = y - window.pageYOffset;
      return {x : x, y : y};
    }
  }

  zoomOut = () => {
    /*additional check to prevent zoomOut from firing multiple times on singular click / touch */ 
    if(document.querySelector(`.is-visible #${this.resultImage}`) || (!this.splideExists && !document.querySelector(`.is-visible #${this.resultImage}`))){
      this.trigger.dataset.zoomed = "off",
      this.querySelector(".img-zoom-lens") && this.querySelector(".img-zoom-lens").remove();
      let zoomedImage;
      this.splideExists ?  (zoomedImage = `.is-visible #${this.resultImage}`) : (zoomedImage = `#${this.resultImage}`);
      if(document.querySelector(zoomedImage)) document.querySelector(zoomedImage).style = "";
    }
  }

}

customElements.define("zoomable-image", ZoomableImage);
